<app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
  <div class="flex flex-col h-full">
    <div class="text-subheading-large text-headingText p-5 pt-4 shrink-0">{{ title }}</div>
    <div class="p-5 flex-1">
      @if (loading) {
      <div class="flex items-center justify-between gap-3 h-[200px]">
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
        <p-skeleton height="100%" width="1.5rem" />
      </div>
      } @else if (error) {
      <div class="flex items-center justify-center h-full text-bodyText">Failed to load revenue stream.</div>
      } @else if (!hasChartData) {
      <div class="flex items-center justify-center h-full text-bodyText">No data available</div>
      } @else {
      <app-stacked-chart [stackedChartData]="chartData" [chartOptions]="resolvedChartOptions"></app-stacked-chart>
      }
    </div>
  </div>
</app-card>
